import ListItemsPage from '../views/ListItems/ListItemsPage'
import ListItemsPageNew from '../views/ListItemsV5/ListItemsContainer'
import HomeOld from './../views/Home/HomeOld'
import UserPage from '../views/User/UserPage'
import BoxesPage from '../views/Boxes/BoxesPage'
import BoxesPage2 from '../views/Boxes2/BoxesPage'
import BoxDetailsPage from '../views/BoxDetails/BoxDetailsPage'
import BoxDetailsPage2 from '../views/BoxDetails2/BoxDetailsPage'
import NextBoxPageContainer from '../views/NextBox/components/NextBoxPageContainer'
import NextBoxFBAPageContainer from "../views/NextBoxFBA/components/NextBoxFBAPageContainer"
import NextItemsPageContainer from '../views/ListNextItemsV4/components/NextItemsPageContainer'
import ItemDetailPageContainer from '../views/ItemDetail/components/ItemDetailPageContainer'
import SkuContainer from "../views/SkuPage/SkuContainer"
import OrdersReportContainer from "../views/OrdersReport/OrdersReportContainer"
import SkuDetailContainer from "../views/SkuDetail/components/SkuDetailContainer"
import ReGenerateLabelsContainer from '../views/ReGenerateLabels/components/ReGenerateLabelsContainer'
import SettingShippingRuleContainer from "../views/SettingShippingRule/components/SettingShippingRuleContainer"
import NewShippingRule from "../views/SettingShippingRuleNew/components/NewShippingRule"
import EditShippingRule from "../views/SettingShippingRuleEdit/components/EditShippingRule"
import UsersStaticsDetailContainer from '../views/UsersStaticsDetail/components/UsersStaticsDetailContainer'
import StaticOverviewContainer from "../views/StaticsOverview/components/StaticOverviewContainer"
import RequestUpdateContainer from "../views/RequestUpdate/components/RequestUpdateContainer"
import PriorityStorePageContainer from '../views/PriorityStore/components/PriorityStorePageContainer'
import BatchShipCreatePageContainer from '../views/BatchShip/Components/BatchShipCreatePageContainer'
import TagBrandNewContainer from '../views/TagBrandNew/components/TagBrandNewContainer'
import TagBrandEditContainer from '../views/TagBrandEdit/components/TagBrandEditContainer'
import TagBrandPageContainer from '../views/TagBrand/components/TagBrandPageContainer'
import BrandsRuleCreatePageContainer from '../views/CreateBrandsRule/BrandsRuleCreatePageContainer'
import BrandsRulePageContainer from '../views/BrandsRule/components/BrandsRulePageContainer'
import ListBrandsContainer from "../views/ListBrands/components/ListBrandsContainer"
import ListItemMarkErrorContainer from '../views/ListItemMarkError/components/ListItemMarkErrorContainer'
import SettingShippingCarrierContainer from '../views/SettingShippingCarrier/components/SettingShippingCarrierContainer'
import SettingShippingBox from '../views/SettingShippingBox/components/SettingShippingBox'
import MaterialContainer from '../views/MaterialPage/components/MaterialContainer'
import NewSettingBoxes from "../views/SettingBoxesNew/components/NewSettingBoxes"
import EditSettingBoxes from '../views/SettingBoxesEdit/components/EditSettingBoxes'
import SettingBoxesContainer from '../views/SettingBoxes/components/SettingBoxesContainer'
import ProductionMethodsContainer from '../views/ProductionMethods/components/ProductionMethodsContainer'
import ProductionStageContainer from '../views/ProductionStage/components/ProductionStageContainer'
import ProductionStageCreateContainer from '../views/ProductionStageCreate/components/ProductionStageCreateContainer'
import ProductionProcess from '../views/ProductionProcess/components/ProductionProcessContainer'
import CreateProductionProcess from '../views/ProductionProcess/components/CreateProductionProcess'
import EditProductionProcess from '../views/ProductionProcess/components/EditProductionProcess'
import IssuesManagementReport from '../views/IssuesManagementReport/components/PackageIssueReportContainer'
import NextBoxDiaryContainer from '../views/NextBoxDiary/components/NextBoxDiaryContainer'
import NextBoxDiaryDetailsContainer from '../views/NextBoxDiaryDetails/components/NextBoxDiaryDetailsContainer'
import CombineShipCreatePageContainer from '../views/CombineShip/Components/CombineShipCreatePageContainer'
import JobsContainer from '../views/Jobs/components/JobsContainer'
import JobDetailContainer from '../views/JobDetail/components/JobDetailContainer'
import CategoryPage from '../views/Categorys/components/CategoryPage'
import MaterialCodeContainer from '../views/MaterialCode/components/MaterialCodeContainer'

const route = [
    {
        path: '/home-old',
        component: HomeOld,
    },
    {
        path: '/admin/v1',
        component: ListItemsPage,
    },
    {
        path: '/admin',
        component: ListItemsPageNew
    },
    {
        path: '/user',
        component: UserPage,
    },
    {
        path: '/boxes',
        component: BoxesPage,
        exact: true,
    },
    {
        path: '/boxes/:box_id',
        component: BoxDetailsPage,
    },
    {
        path: '/boxes2',
        component: BoxesPage2,
        exact: true,
    },
    {
        path: '/boxes2/:box_id',
        component: BoxDetailsPage2,
    },
    {
        path: '/next-boxes/:boxId',
        component: NextBoxPageContainer,
    },
    {
        path: '/next-boxes-fba/:boxId',
        component: NextBoxFBAPageContainer,
    },
    {
        path: '/next-items',
        component: NextItemsPageContainer,
        exact: true,
    },
    {
        path: '/next-item-detail',
        component: ItemDetailPageContainer,
        exact: true,
    },
    {
        path: '/1',
        to: '/next-item-detail',
        redirect: true,
    },
    {
        path: '/sku-manager',
        component: SkuContainer,
    },
    {
        path: '/priority-store',
        component: PriorityStorePageContainer,
        roles: ['fac_admin', 'fac_ffm'],
    },
    {
        path: '/sku-detail/:skuID',
        component: SkuDetailContainer,
        exact: true,
    },
    {
        path: '/orders-report',
        component: OrdersReportContainer
    },
    {
        path: '/re-generate-labels',
        component: ReGenerateLabelsContainer
    },
    {
        path: '/shipping-rule',
        component: SettingShippingRuleContainer,
        exact: true,
    },
    {
        path: '/shipping-rule-new',
        component: NewShippingRule,
        exact: true,
    },
    {
        path: '/shipping-rule/:shipping_rule_id',
        component: EditShippingRule,
        exact: true,
    },
    {
        path: '/users-statics-detail',
        component: UsersStaticsDetailContainer,
        exact: true,
    },
    {
        path: '/static-overview',
        component: StaticOverviewContainer,
        exact: true,
    },
    {
        path: '/request-update',
        component: RequestUpdateContainer,
        exact: true,
    },
    {
        path: '/batch-ship/create',
        component: BatchShipCreatePageContainer,
        exact: true,
    },
    {
        path: '/batch-ship/:id',
        component: BatchShipCreatePageContainer,
        exact: true,
    },
    {
        path: '/tag-brand-new',
        component: TagBrandNewContainer,
        exact: true,
    },
    {
        path: '/tag-brand-edit/:id',
        component: TagBrandEditContainer,
        exact: true,
    },
    {
        path: '/tag-brands',
        component: TagBrandPageContainer,
        exact: true,
    },
    {
        path: '/brands-rule/create',
        component: BrandsRuleCreatePageContainer,
        exact: true,
    },
    {
        path: '/brands-rule/:id',
        component: BrandsRuleCreatePageContainer,
        exact: true,
    },
    {
        path: '/brands-rule',
        component: BrandsRulePageContainer,
        exact: true,
    },
    {
        path: '/brands',
        component: ListBrandsContainer,
        exact: true,
        roles: ['fac_admin', 'fac_ffm'],
    },
    {
        path: '/items-mark-error',
        component: ListItemMarkErrorContainer,
        exact: true
    },
    {
        path: '/shipping-carrier',
        component: SettingShippingCarrierContainer,
        exact: true,
    },
    {
        path: '/shipping-carrier/:shipping_carrier_id/shipping-box',
        component: SettingShippingBox,
        exact: true,
    },
    {
        path: '/setting-boxes',
        component: SettingBoxesContainer,
        exact: true,
    },
    {
        path: '/setting-boxes-new',
        component: NewSettingBoxes,
        exact: true,
    },
    {
        path: '/setting-boxes/:setting_box_id',
        component: EditSettingBoxes,
        exact: true,
    },
    {
        path: '/materials',
        component: MaterialContainer,
        exact: true,
    },
    {
        path: '/production-methods',
        component: ProductionMethodsContainer,
        exact: true,
    },
    {
        path: '/production-stage',
        component: ProductionStageContainer,
        exact: true,
    },
    {
        path: '/production-stage/create',
        component: ProductionStageCreateContainer,
        exact: true,
    },
    {
        path: '/production-stage/:id',
        component: ProductionStageCreateContainer,
        exact: true,
    },
    {
        path: '/production-process',
        component: ProductionProcess,
        exact: true,
    },
    {
        path: '/production-process-create',
        component: CreateProductionProcess,
        exact: true,
    },
    {
        path: '/production-process/:id',
        component: EditProductionProcess,
        exact: true,
    },
    {
        path: '/issues-management/report',
        component: IssuesManagementReport,
        exact: true,
    },
    {
        path: '/next-boxes-diary',
        component: NextBoxDiaryContainer,
        exact: true,
    },
    {
        path: '/next-boxes-diary/:id',
        component: NextBoxDiaryDetailsContainer,
        exact: true,
    },
    {
        path: '/combine-ship/create',
        component: CombineShipCreatePageContainer,
        exact: true,
    },
    {
        path: '/combine-ship/:id',
        component: CombineShipCreatePageContainer,
        exact: true,
    },
        {
        path: '/jobs',
        component: JobsContainer,
        exact: true,
    },
    {
        path: '/jobs/:id',
        component: JobDetailContainer,
    },
    {
        path: '/categories',
        component: CategoryPage,
        exact: true,
    },
    {
        path: '/material-code',
        component: MaterialCodeContainer,
        exact: true,
    },
]

export default route
